import axios from '@/utils/api';

const statusesQuery = `
  query {
    codebaseStatuses {
      edges {
        node { name }
      }
    }
  }
`

export default {
  namespaced: true,

  state: {
    statuses: []
  },

  getters: {
    getStatuses (state) {
      return state.statuses
    }
  },

  actions: {
    async fetchStatuses({ commit, rootState }) {
      const response = await axios.post('/', {
        query: statusesQuery
      },
      {
        headers: {
          'Authorization': rootState.auth.authToken
        }
      })

      if (response.status === 200) {
        commit('setStatuses', response.data.data.codebaseStatuses.edges)
      } 
    }
   },

  mutations: {
    setStatuses(state, statuses) {
      state.statuses = statuses
    }
  }
}